import './post.scss'

import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Link, ImageDiv } from '../global'
import { AuthorSocials } from './'
import { authorClasses } from '../../utils'

const AuthorDetail = ({ authorDetails }) => {
  // // Meta author info
  const {
    firstName,
    lastName,
    name,
    description,
    authorUri,
    email,
    socialLinks,
    userSettings: { profileImg },
    roles,
  } = authorDetails

  const authorRole = roles?.roles[0]['name'] || ''

  // Sanitise author name
  const sanitizeName = (first, last) => `${first || ''} ${last || ''}`

  const authorName = name || `${sanitizeName(firstName, lastName)}`

  if (!authorName || authorName === ' ') return null

  return (
    <Fragment>
      <div className="author-container">
        <div className={authorClasses('author-box', authorRole)}>
          <div className="author-box__upper">
            {profileImg?.sourceUrl && (
              <ImageDiv
                className={authorClasses('portrait', authorRole)}
                src={profileImg.sourceUrl}
                alt={profileImg.altText}
              />
            )}
            <div
              className={`author-info ${!profileImg?.sourceUrl ? 'full' : ''}`}
            >
              <p className="pg-bold">{authorName}</p>
              {description && <p className="text-xsmall">{description}</p>}
            </div>
          </div>
          {authorUri && (
            <div className="author-box__lower">
              <Link to={authorUri} className="button-link">
                fler inlägg
              </Link>
              <a
                href={`mailto:${email || ''}`}
                className={authorClasses('social-email', authorRole)}
                aria-label={`Send email to ${email || ''}`}
              >
                <span>@</span>
              </a>
            </div>
          )}
        </div>
        {socialLinks && (
          <AuthorSocials socialLinks={socialLinks} role={authorRole} />
        )}
      </div>
    </Fragment>
  )
}

AuthorDetail.propTypes = {
  authorDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    authorUri: PropTypes.string,
    email: PropTypes.string,
    userSettings: PropTypes.shape({
      profileImg: PropTypes.shape({
        sourceUrl: PropTypes.string,
        altText: PropTypes.string,
      }),
    }),
    roles: PropTypes.shape({
      roles: PropTypes.array,
    }),
  }),
}

export default AuthorDetail
